export { buildWidgetId, buildWidgetInstanceId } from "./buildWidgetId";
export { registerWidget } from "./registerWidget";
